import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/common/jwt.service";
import { API_URL } from "@/common/config";

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_URL;
  },

  setHeader() {
    // Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    Vue.axios.defaults.headers.common["Authorization"] = `Token ${JwtService.getToken()}`;
  },

  query(resource, params) {
    var request = resource
    if (params != null && params != undefined) {
      request += "?filter=" + JSON.stringify(params) + "&"
    }
    return Vue.axios.get(res(request)).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  get(resource, params) {
    var request = resource
    if (params != null && params != undefined) {
      request += "?filter=" + JSON.stringify(params) + "&"
    }

    let result = Vue.axios.get(res(request)).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
    return result
  },

  post(resource, params) {
    console.log("post")
    console.log(resource)
    console.log(params)
    return Vue.axios.post(`${res(resource)}`, params);
  },

  update(resource, params) {
    console.log("update")
    console.log(resource)
    console.log(params)
    return Vue.axios.put(`${res(resource)}`, params);
  },

  put(resource, params) {
    return Vue.axios.put(`${res(resource)}`, params);
  },

  delete(resource) {
    return Vue.axios.delete(res(resource)).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  }
};

// For authentication
function res(resource) {
  if (JwtService.getToken()) {
    return resource + `?access_token=${JwtService.getToken()}`
  } else {
    return resource
  }
}

export default ApiService;

export const TagsService = {
  get() {
    return ApiService.get("tags");
  }
};

export const BooksService = {
  query(params) {
    return ApiService.query("books", params);
  },
  get(slug, params) {
    return ApiService.get(`books/${slug}`, params);
  },
  create(params) {
    return ApiService.post("books", params);
  },
  createRelated(resource, params) {
    return ApiService.post(`books/${resource}`, params);
  },
  update(slug, params) {
    console.log("in update bookservice")
    return ApiService.update(`books/${slug}`, params );
  },
  destroy(slug) {
    return ApiService.delete(`books/${slug}`);
  }
};

export const AuthorService = {
  query(params) {
    return ApiService.query("authors", params);
  },
  get(slug, params) {
    return ApiService.get(`authors/${slug}`, params);
  },
  create(params) {
    return ApiService.post("authors", params);
  },
  createRelated(resource, params) {
    return ApiService.post(`authors/${resource}`, params);
  },
  update(slug, params) {
    return ApiService.update(`authors/${slug}`, params);
  },
  destroy(slug) {
    return ApiService.delete(`authors/${slug}`);
  }
};

export const DynamicService = {
  query(resource, params) {
    return ApiService.query(resource, params);
  },
  get(resource, slug, params) {
    return ApiService.get(`${resource}/${slug}`, params);
  },
  create(resource, params) {
    return ApiService.post(resource, params); // Attention-> See functions in other Service
  },
  update(resource, slug, params) {
    return ApiService.update(`${resource}/${slug}`, params); // Attention-> See functions in other Service
  },
  destroy(resource, slug) {
    return ApiService.delete(`${resource}/${slug}`);
  }
};
